import DocumentEditor from './DocumentEditor';

export default DocumentEditor;
